export const queryKeys = {
	lydiaPage: {
		prefix: () => ['lydiaPage'] as const,
		getLydiaPageInfo: (pageTag: string) => [...queryKeys.lydiaPage.prefix(), pageTag] as const
	},
	moneyPot: {
		prefix: () => ['moneyPot'] as const,
		getMoneyPotInfo: (slug: string) => [...queryKeys.moneyPot.prefix(), slug] as const
	},
	featureFlipping: {
		prefix: () => ['featureFlipping'] as const,
		getFeatureFlipping: () => [...queryKeys.featureFlipping.prefix(), 'getFeatureFlipping'] as const
	},
	successInfo: {
		prefix: () => ['successInfo'] as const,
		getSuccessCollectInfo: (transactionIdentifier: string, collectSlug: string) =>
			[...queryKeys.successInfo.prefix(), transactionIdentifier, collectSlug] as const
	},
	successLydiaPageInfo: {
		prefix: () => ['successLydiaPageInfo'] as const,
		getSuccessLydiaPageInfo: (identifier: string) =>
			[...queryKeys.successLydiaPageInfo.prefix(), identifier] as const
	}
}
